/**
 * Environment configuration
 * Central access point for all environment variables.
 * Validates required variables at startup.
 */

interface EnvConfig {
  // Supabase
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  SUPABASE_PROJECT_ID: string;

  // App
  APP_ENV: 'development' | 'staging' | 'production';
  APP_URL: string;
  APP_NAME: string;

  // Feature flags (client-side defaults, overridden by DB)
  ENABLE_GEOLOCATION: boolean;
  ENABLE_GEOFENCE: boolean;
}

function getEnv(): EnvConfig {
  const raw = {
    SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL ?? '',
    SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '',
    SUPABASE_PROJECT_ID: import.meta.env.VITE_SUPABASE_PROJECT_ID ?? '',
    APP_ENV: (import.meta.env.VITE_APP_ENV as EnvConfig['APP_ENV']) ?? 'development',
    APP_URL: import.meta.env.VITE_APP_URL ?? window.location.origin,
    APP_NAME: import.meta.env.VITE_APP_NAME ?? 'Employee TMS',
    ENABLE_GEOLOCATION: import.meta.env.VITE_ENABLE_GEOLOCATION !== 'false',
    ENABLE_GEOFENCE: import.meta.env.VITE_ENABLE_GEOFENCE !== 'false',
  };

  // Validate required variables
  const required: (keyof EnvConfig)[] = ['SUPABASE_URL', 'SUPABASE_ANON_KEY'];
  for (const key of required) {
    if (!raw[key]) {
      console.error(`[ENV] Missing required environment variable: VITE_${key}`);
    }
  }

  return raw;
}

export const env = getEnv();

export const isDev = env.APP_ENV === 'development';
export const isStaging = env.APP_ENV === 'staging';
export const isProd = env.APP_ENV === 'production';
